import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import { PurchaseMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { LastDaySaleBannerContent } from './LastDaySaleBannerContent';
import s from './SaleBanner.scss';
import { SaleBannerContent } from './SaleBannerContent';

interface SaleBannerProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const SaleBannerComp: React.FunctionComponent<SaleBannerProps> = ({
  rootStore,
}) => {
  const { purchaseMode } = rootStore.appStore.appContext;
  const { theme } = usePageModeContext();

  return (
    <div className={classNames(s.saleStrip, theme)} data-hook='sale-banner'>
      <div className={s.stripBanner}>
        <div className={s.stripCenter}>
          {purchaseMode === PurchaseMode.LAST_DAY_SALE ? (
            <LastDaySaleBannerContent />
          ) : (
            <SaleBannerContent />
          )}
        </div>
      </div>
    </div>
  );
};

export const SaleBanner = withInjectedRootStore(
  withExperiments(SaleBannerComp),
);
